module.exports = "https://static.weeecdn.net/mweb/_next/static/images/landing-bg-47127870739c50970effeffab04eabde.png";